import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({
    baseUrl: '',
  }),
  tagTypes: [
    'User',
    'Account',
    'Company',
    'loadList',
    'Inv',
    'Quote',
    'Image',
    'ExchangeRates',
    'Countries',
    'Currencies',
  ],
  endpoints: () => ({}),
});
